/**
 * Read a user-provided lyric file without assuming every desktop lyric editor
 * wrote UTF-8. File.text() is specified as UTF-8 only, while LRC/TTML files
 * exported by Windows tools commonly carry an explicit UTF-16 BOM.
 *
 * We intentionally only branch on an explicit BOM. Guessing a legacy code
 * page from arbitrary bytes can silently change lyrics, so BOM-less files keep
 * the existing UTF-8 behavior.
 */
export async function readLyricText(file: Blob): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  if (bytes[0] === 0xff && bytes[1] === 0xfe) return new TextDecoder('utf-16le').decode(bytes.subarray(2));
  if (bytes[0] === 0xfe && bytes[1] === 0xff) return new TextDecoder('utf-16be').decode(bytes.subarray(2));
  return new TextDecoder('utf-8').decode(bytes);
}
